import React, { useLayoutEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './FotoFunTitle.module.scss';

export const FotoFunTitle = () => {

    const { t } = useTranslation();

        const textRef = useRef<SVGTextElement | null>(null);
        const [textWidth, setTextWidth] = useState(70);

        const title = t('photo_prints.photo_fun');

        const iconPlusPaddingWidth = 58;
        const widthValue =  textWidth ;
        const heightValue = 36;
        const viewBoxValue = `0 0 ${widthValue} ${heightValue}`;

        useLayoutEffect(() => {
            if (textRef.current) {
                const bbox = textRef.current.getBBox();
                setTextWidth(bbox.width+ iconPlusPaddingWidth);
            }
        }, [title]);

    return (
            <svg
                viewBox={viewBoxValue}
                width={widthValue}
                height={heightValue}
                xmlns="http://www.w3.org/2000/svg"
                style={{ display: 'block' }}
                className={styles.svgBorder}
            >
                <defs>
                    <linearGradient id="rainbowGradient" x1="0" y1="0" x2="100" y2="0" gradientUnits="userSpaceOnUse">
                        <stop offset="0%" stopColor="#F4D733">
                            <animate attributeName="stop-color"
                                    values="#F4D733;#FF2911;#DC27E0;#6E5EF8;#2EB7E5;#36EB84;#F4D733"
                                    dur="3s"
                                    repeatCount="indefinite"
                                    begin="0s" />
                        </stop>
                        <stop offset="20%" stopColor="#FF2911">
                            <animate attributeName="stop-color"
                                    values="#F4D733;#FF2911;#DC27E0;#6E5EF8;#2EB7E5;#36EB84;#F4D733"
                                    dur="3s"
                                    repeatCount="indefinite"
                                    begin="0.43s" />
                        </stop>
                        <stop offset="40%" stopColor="#DC27E0">
                            <animate attributeName="stop-color"
                                    values="#F4D733;#FF2911;#DC27E0;#6E5EF8;#2EB7E5;#36EB84;#F4D733"
                                    dur="3s"
                                    repeatCount="indefinite"
                                    begin="0.86s" />
                        </stop>
                        <stop offset="60%" stopColor="#6E5EF8">
                            <animate attributeName="stop-color"
                                    values="#F4D733;#FF2911;#DC27E0;#6E5EF8;#2EB7E5;#36EB84;#F4D733"
                                    dur="3s"
                                    repeatCount="indefinite"
                                    begin="1.29s" />
                        </stop>
                        <stop offset="80%" stopColor="#2EB7E5">
                            <animate attributeName="stop-color"
                                    values="#F4D733;#FF2911;#DC27E0;#6E5EF8;#2EB7E5;#36EB84;#F4D733"
                                    dur="3s"
                                    repeatCount="indefinite"
                                    begin="1.72s" />
                        </stop>
                        <stop offset="100%" stopColor="#36EB84">
                            <animate attributeName="stop-color"
                                    values="#F4D733;#FF2911;#DC27E0;#6E5EF8;#2EB7E5;#36EB84;#F4D733"
                                    dur="3s"
                                    repeatCount="indefinite"
                                    begin="2.15s" />
                        </stop>
                    </linearGradient>
                </defs>

                <g transform="translate(16, 9) scale(.9)">
                    <path
                        d="M2 2H4M3 1V3M9.5 1L9 3M16 2H18M17 1V3M13 6L12 7M16 10L18 9.5M16 16H18M17 15V17M12 13.518L5.48205 7L1.09205 16.58C1.00528 16.766 0.977846 16.9742 1.01347 17.1763C1.0491 17.3785 1.14605 17.5647 1.29118 17.7099C1.43632 17.855 1.62259 17.952 1.82472 17.9876C2.02685 18.0232 2.23505 17.9958 2.42105 17.909L12 13.518Z"
                        stroke="url(#rainbowGradient)"
                        fill="none"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>

                <text
                    ref={textRef}
                    x="42"
                    y="19"
                    fontSize="20"
                    fontFamily="sans-serif"
                    fontWeight="700"
                    fill="url(#rainbowGradient)"
                    textRendering="geometricPrecision"
                    shapeRendering="geometricPrecision"
                    dominantBaseline="middle"
                >
                    {title}
                </text>
            </svg>
    );
};